module.exports = __webpack_public_path__ + "img/upgrade-btn.a39efe93.png";